module.exports = __webpack_public_path__ + "static/media/Bell.b983ad36.svg";